<!-- eslint-disable no-unused-vars -->
<script setup>
import { ref, onMounted, useTemplateRef, computed, defineEmits, defineExpose, defineProps, getCurrentInstance } from 'vue'
import { filePreview } from "@/api/global.js";
import { MY_CONSTANTS } from '@/util/constants'
import { ElMessage } from 'element-plus'
import { useFile } from '@/hooks/useFile'
import { useGetImg } from './useGetImg'
import { breakupfile } from '@/port/common/homeworkCorrection.js'
import { getapprovinglist, issuescandevicetask, getscanfile, getscandevicetaskstatus } from '@/port/schoolInstrument/appConfig'
import { cloneDeep } from 'lodash';
import chooseScanner from './chooseScanner.vue';

let token = ''
let scannerParams = {}
const $imgurl = MY_CONSTANTS.$imgurl
const allowedExtensions = ['jpg', 'jpeg', 'png', 'webp']
const allcompressedFiles = ['zip', '7z', 'rar']
const allDocumentFiles = ['pdf', 'doc', 'docx', 'xls', 'xlsx']

const props = defineProps({
  uploadInfo: {
    type: Object,
    default: () => ({})
  }
})

const uploadList = ref([])
const scannerInfo = ref({})
const isLoading = ref(false)
const currentUploadType = ref(1)
const loadingText = ref('正在上传文件,请稍后...')

const elImgRef = useTemplateRef('elImgRef')
const uploadRef = useTemplateRef('uploadRef')
const chooseScannerRef = useTemplateRef('chooseScannerRef')

const { validateFile, upload } = useFile()
const { getImg } = useGetImg()

const emit = defineEmits(['confirm'])


onMounted(() => {
  const user = localStorage.getItem('user')
  if (user) {
    token = JSON.parse(user).accesstoken
  }
})

const goUpload = async (type) => {
  currentUploadType.value = type
  if (type === 1 || type === 2) {
    loadingText.value = '正在上传文件,请稍后...'
    uploadRef.value.value = null
    uploadRef.value.accept = getAccept.value
    uploadRef.value.click()
  } else if (type === 3) {
    loadingText.value = '已选择扫描机，请到扫描机放入文件开始扫描...'
    if (scannerInfo.value.scannerList) {
      openChooseScanner()
      return
    }
    const approvalId = otherConfig.value.appId
    if (!approvalId) {
      ElMessage.error('请先选择扫描仪数据表')
      return
    }
    const res = await getapprovinglist({
      curpage: 0,
      pagesize: 0,
      approvalId
    })
    if (res.code === 0) {
      const data = res.data.map(item => {
        const obj = {
          approvingId: item.approvingId,
          approvalId: item.approvalId,
        }
        const formdata = typeof item.formdata === 'string' ? JSON.parse(item.formdata) : item.formdata
        return {
          ...obj,
          ...formdata
        }
      })
      const scannerList = data.map(item => {
        return {
          scannerName: item[otherConfig.value.scannerName],
          scannerId: item[otherConfig.value.scannerId],
          approvingId: item.approvingId
        }
      })
      scannerInfo.value.dataList = data
      scannerInfo.value.scannerList = scannerList
      openChooseScanner()
    }
  }
}

const openChooseScanner = () => { 
  chooseScannerRef.value.open(scannerInfo.value.scannerList)
}

const openScanner = async (scanner) => {
  isLoading.value = true
  const taskId = crypto.randomUUID()
  const param = {
    scanDeviceSn: scanner.scannerId,
    taskId,
    taskName: scannerTaskName.value,
  }
  scannerParams.taskId = taskId
  scannerParams.scanDeviceSn = param.scanDeviceSn
  const res = await issuescandevicetask(param).catch(() => {
    isLoading.value = false
  })
  if (res.code === 0) {
    setTimeout(() => {
      getScannerList(3000)
    }, 5000);
  } else {
    ElMessage.error(res.msg)
  }
}

const getScannerList = async (delay = 2000) => {
  const res = await getscandevicetaskstatus(scannerParams).catch(() => {
    isLoading.value = false
  })
  if (res.code === 0) {
    const res1 = await getscanfile(scannerParams).catch(() => {
      isLoading.value = false
    })
    if (res1.code === 0) {
      // 返回数据
      addFile(res1.data)
      isLoading.value = false
    } else {
      ElMessage.error(res1.msg)
      isLoading.value = false
    }
  } else {
    setTimeout(() => {
      getScannerList(3000)
    }, delay);
  }
}

// const openScanner = async (scanner) => {
//   isLoading.value = true
//   const taskId = '12323j23h1j2k3h1j3123jk'
//   const param = {
//     scanDeviceSn: '041A25360094A1',
//     taskId,
//     taskName: '作业扫描',
//   }
//   scannerParams.taskId = taskId
//   scannerParams.scanDeviceSn = param.scanDeviceSn
//   const res = await issuescandevicetask(param).catch(() => {
//     isLoading.value = false
//   })
//   if (res.code === 0) {
//     // TODO
//     setTimeout(() => {
//       getScannerList(3000)
//     }, 5000);
//   } else {
//     ElMessage.error(res.msg)
//   }
// }

// const getScannerList = async (delay = 3000) => {
//   const res = await getscandevicetaskstatus(scannerParams).catch(() => {
//     isLoading.value = false
//   })
//   if (res.code === 0) {
//     const res1 = await getscanfile(scannerParams).catch(() => {
//       isLoading.value = false
//     })
//     if (res1.code === 0) {
//       // 返回数据
//       addFile(res1.data)
//       isLoading.value = false
//     }
//   } else {
//     setTimeout(() => {
//       getScannerList(3000)
//     }, delay);
//   }
// }

const reset = () => {
  uploadList.value = []
}

const scannerConfirm = (id) => {
  const scanner = scannerInfo.value.scannerList.find(item => item.approvingId === id)
  openScanner(scanner)
}

const openList = (item, idx) => {
  if (item.type === 'document') {
    filePreview(item, false)
  } else if (item.type === 'image') {
    const ref = elImgRef.value[idx]
    ref.showPreview()
  }
}

const delList = (idx) => {
  uploadList.value.splice(idx, 1)
}


const beforeUpload = (file) => {
  // 1. 获取文件后缀名
  const fileName = file.name
  const fileExtension = fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase()
  // 2. 定义允许的后缀名列表
  const isAllowedExtension = allowedExtensions.includes(fileExtension)

  // 3. 如果任一校验失败，则给出错误提示并阻止上传
  if (!isAllowedExtension) {
    ElMessage.error({
      message: '上传图片只能是 JPG、PNG 或 WEBP 格式!',
      grouping: true
    })
    return false
  }
  return true
}

const onChange = async (file) => {
  const flag = beforeUpload(file)
  if (!flag) return
  const obj = {
    value: file.raw,
    name: file.name,
    previewUrl: URL.createObjectURL(file.raw),
    isManual: true,
    type: 'image',
    fileType: file.raw.type,
    url: '',
    info: {}
  }
  uploadList.value.push(obj)
}

const uploadChange = async () => {
  const files = uploadRef.value.files
  if (!files) return
  const urls = []
  isLoading.value = true
  for (const file of files) {
    const fileType = currentUploadType.value === 2 ? allDocumentFiles : allcompressedFiles
    const { validate, ext } = validateFile(file.name, fileType)
    if (!validate) {
      ElMessage.error(`请上${allcompressedFiles.join('/')}传格式文件`)
      isLoading.value = false
      return
    }
    const url = await upload(file)
    urls.push('/userfiles/' + url)
  }
  try {
    const fileInfo = await breakupfile({ paths: urls, fieldtype: curUploadFileType.value }).catch(()=> isLoading.value === false)
    if (fileInfo && fileInfo.code === 0) {
      addFile(fileInfo.data)
    }
  } catch (error) {
    console.log(error, 'error')
  } finally {
    isLoading.value = false
  }
}

const addFile = (list = []) => {
  for (const file of list) {
    const originalType = file.originalPath.substring(file.originalPath.lastIndexOf('.') + 1)
    const obj = {
      name: '',
      url: '',
      isManual: false,
      type: curUploadFileType.value === 'image' ? 'image' : 'document',
      fileType: '',
      originalPath: file.originalPath,
      previewUrl: '',
      info: {}
    }
    if (allowedExtensions.includes(originalType)) {
      // 说明是图片
      obj.type = 'image'
      obj.previewUrl = $imgurl + file.originalPath
      obj.fileType = originalType
      obj.name = file.originalPath.substring(file.originalPath.lastIndexOf('-') + 1)
      obj.url = file.originalPath
      uploadList.value.push(cloneDeep(obj))
    } else {
      if (curUploadFileType.value === 'image') {
        for (const path of file.extractPaths) {
          obj.name = path.substring(path.lastIndexOf('-') + 1)
          obj.url = '/userfiles/' + path
          obj.fileType = path.substring(path.lastIndexOf('.') + 1)
          obj.previewUrl = $imgurl + '/userfiles/' + path
          uploadList.value.push(cloneDeep(obj))
        }
      } else {
        obj.name = file.originalPath.substring(file.originalPath.lastIndexOf('-') + 1)
        obj.url = file.originalPath
        obj.fileType = file.originalPath.substring(file.originalPath.lastIndexOf('.') + 1)
        obj.aiRecognizeUrl = '/userfiles/' + file.extractPaths[0]
        uploadList.value.push(cloneDeep(obj))
      }
    }
  }
}

const confirm = async () => {
  // console.log('确认上传', uploadList.value)
  if (uploadList.value.length === 0) {
    ElMessage.error('请上传文件')
    return
  }
  isLoading.value = true
  // 调上传接口
  loadingText.value = '正在上传文件,请稍后...'
  try {
    for (const ele of uploadList.value) {
      if (ele.isManual) {
        const res = await upload(ele.value)
        const url = '/userfiles/' + res
        ele.previewUrl = $imgurl + url
        ele.url = url
        ele.isManual = false
      }
    }
    emit('confirm', uploadList.value)
  } catch (error) {
    console.log(error, 'error')
  } finally {
    isLoading.value = false
  }
}


// computed
const srcList = computed(() => {
  return uploadList.value.map(item => item.previewUrl)
})

const otherConfig = computed(() => {
  return props.uploadInfo.config.otherConfig || {}
})

const getAccept = computed(() => {
  if (currentUploadType.value === 1) {
    return '.zip, .rar, .7z'
  } else if (currentUploadType.value === 2) {
    return '.pdf, .doc, .docx, .xls, .xlsx'
  } else {
    return '.jpg, .jpeg, .png, .webp'
  }
})

const curUploadFileType = computed(() => {
  const list = props.uploadInfo.list
  if (list && list[0]) {
    return list[0].field.split('_')[1]
  } else {
    return ''
  }
})

const scannerTaskName = computed(() => {
  const customName = otherConfig.value.customName || ''
  const customData = props.uploadInfo.customData || []
  const title = customName.split('_')[0]
  const customValue = customData.find(f => f.title === title)
  let taskName = ''
  if (customValue) {
    taskName = customValue.value
  }
  return taskName
})



defineExpose({
  uploadList,
  reset
})


</script>

<template>
  <div class="l-upload" v-loading="isLoading" :element-loading-text="loadingText">
    <div class="l-upload-btn">
      <div class="btn-style active1" @click="goUpload(1)">
        <i class="iconfont icon-yasuobao"></i>
        使用压缩包上传
      </div>
      <div class="btn-style active2" @click="goUpload(2)">
        <i class="iconfont icon-pdfshangchuan"></i>
        使用pdf/word/excel格式上传
      </div>
      <div class="btn-style active3" @click="goUpload(3)">
        <i class="iconfont icon-saomiaoji"></i>
        使用扫描仪上传
      </div>
    </div>
    <div class="l-upload-list">
      <ul class="l-list">
        <li v-for="(item, idx) in uploadList" :data-index="idx + 1" :key="item" class="l-list-item">
          <template v-if="item.type === 'image'">
            <el-image :initial-index="idx" :preview-src-list="srcList" ref="elImgRef" style="width: 100%;height: 100%;"
              fit="cover" :src="item.previewUrl" lazy></el-image>
          </template>
          <template v-else>
            <div class="l-list-item-document">
              <el-image fit="cover" :src="getImg(item.fileType)" />
              <span style="margin-top: 5px;" class="document-name">{{ item.name }}</span>
            </div>
          </template>
          <div class="l-list-item-model">
            <div class="model-icon icon-magnify" @click="openList(item, idx)">
              <i class="iconfont icon-fangda6"></i>
            </div>
            <div class="model-icon icon-del" @click="delList(idx)">
              <i class="iconfont icon-shanchu6"></i>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="l-upload-container">
      <el-upload action="#" :limit="100" :auto-upload="false" :on-change="onChange" :show-file-list="false"
        :before-upload="beforeUpload" drag multiple accept=".jpg, .jpeg, .png, .webp">
        <div class="el-upload__icon el-icon--upload">
          <el-icon color="#2563EB"><upload-filled /></el-icon>
        </div>
        <div class="el-upload__text">
          <div class="el-upload__text_title">点击或拖拽文件到此处</div>
          <div class="el-upload__text_tips">支持 JPG、PNG、WEBP格式，单次最多 100 张，如需压缩包或PDF上传，请点上方按钮上传</div>
        </div>
      </el-upload>
    </div>
    <div class="l-upload-foot">
      <div class="foot-confirm-btn" @click="confirm">
        <el-icon color="#fff" style="margin-right: 5px;"><upload-filled /></el-icon>
        确认提交
      </div>
    </div>
    <input type="file" ref="uploadRef" multiple :accept="getAccept" @change="uploadChange" hidden />
    <chooseScanner ref="chooseScannerRef" @confirm="scannerConfirm" />
  </div>
</template>

<style scoped lang='scss'>
.l-upload {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 30px;

  &-btn {
    width: 100%;
    display: flex;

    .btn-style {
      height: 40px;
      font-weight: 400;
      font-size: 16px;
      border-radius: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      margin-right: 20px;
      user-select: none;
      padding: 0 20px;

      &:last-of-type {
        margin-right: 0;
      }

      .iconfont {
        margin-right: 8px;
        font-weight: 500;
        font-size: 18px;
      }
    }

    .active1 {
      border: 1px solid #4F46E5;
      color: #4F46E5;
      background-color: #F6F6FF;
    }

    .active2 {
      border: 1px solid #EA580C;
      color: #EA580C;
      background-color: #FFF1EA;
    }

    .active3 {
      border: 1px solid #2563EB;
      color: #2563EB;
      background-color: #F4F7FF;
    }
  }

  &-list {
    width: 100%;
    margin: 30px 0;

    .l-list {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      min-height: 140px;

      &-item {
        width: 120px;
        height: 140px;
        margin-right: 20px;
        margin-bottom: 20px;
        background-color: #F6F6FF;
        border-radius: 8px;
        position: relative;
        overflow: hidden;
        position: relative;
        overflow: hidden;
        border-radius: 8px;

        &-document {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          .el-image {
            width: 42px;
            height: 40px;
          }

          .document-name {
            color: #2563EB;
            font-weight: 400;
            font-size: 14px;
            width: 100%;
            padding: 0 5px;
            text-align: center;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            box-sizing: border-box;
          }
        }

        &::after {
          content: attr(data-index);
          position: absolute;
          left: 0;
          top: 0;
          height: 20px;
          width: 20px;
          border-radius: 0 0 8px 0;
          background-color: rgba(164, 158, 158, 0.8);
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
          font-size: 12px;
        }

        &:last-of-type {
          margin-right: 0;
        }

        &:hover {
          .l-list-item-model {
            right: 0;
          }
        }

        &-model {
          background-color: #0000007d;
          width: 100%;
          height: 100%;
          position: absolute;
          right: -100%;
          top: 0;
          z-index: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.3s;

          .model-icon {
            width: 32px;
            height: 32px;
            border-radius: 25px;
            background-color: rgba(164, 158, 158, 0.8);
            display: flex;
            align-items: center;
            justify-content: center;

            .iconfont {
              font-size: 24px;
              color: #fff;
              cursor: pointer;
            }
          }

          .icon-magnify {
            margin-right: 10px;

            &:hover {
              background-color: #26A3F6;
            }
          }

          .icon-del {
            &:hover {
              background-color: #EF4446;
            }
          }
        }
      }
    }
  }

  ::v-deep &-container {
    .el-upload {
      .el-upload-dragger {
        height: 414px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 0;
        background-color: #F5F8FF;

        .el-upload__icon {
          width: 90px;
          height: 90px;
          border-radius: 50%;
          background-color: #DBEAFE;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .el-upload__text {
          &_title {
            color: #4E4E4D;
            font-weight: 400;
            font-size: 24px;
          }

          &_tips {
            color: #4E4E4D;
            font-weight: 400;
            font-size: 16px;
            margin-top: 20px;
          }
        }
      }
    }
  }

  &-foot {
    width: 100%;
    display: flex;
    margin-top: 30px;
    align-items: center;
    justify-content: flex-end;

    .foot-confirm-btn {
      width: 140px;
      height: 40px;
      border-radius: 4px;
      background: linear-gradient(46.68deg, rgba(37, 170, 246, 1) 0%, rgba(39, 145, 245, 1) 24.94%, rgba(111, 105, 255, 1) 77.88%, rgba(166, 107, 255, 1) 100%);
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      font-weight: 400;
      font-size: 16px;
      cursor: pointer;
      user-select: none;
    }
  }
}
</style>
